import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import moment from "moment";
import PropTypes from "prop-types";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableContainer from "@material-ui/core/TableContainer";
import TableFooter from "@material-ui/core/TableFooter";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import IconButton from "@material-ui/core/IconButton";
import FirstPageIcon from "@material-ui/icons/FirstPage";
import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";
import LastPageIcon from "@material-ui/icons/LastPage";
import Container from "@material-ui/core/Container";
import SearchRoundedIcon from "@material-ui/icons/SearchRounded";
import NoData from "../svgIcons/NoData";
import Spinner from "../Spinner/Spinner";
import { useSnackbar } from "react-simple-snackbar";
import { Checkbox, useMediaQuery } from "@material-ui/core";
import { DatePicker } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import Button from "@material-ui/core/Button";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import {
  downloadChecksAction,
  getChecksAction,
} from "../../actions/checkActions";
import { useDebounce } from "../../utils/utils";
import ChecksModal from "./ChecksModal";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const inputStyle = {
  padding: "0.75rem 0.75rem",
  width: "50%",
  fontSize: "0.8rem",
  lineHeight: 1.25,
  color: "#55595c",
  backgroundColor: "#fff",
  backgroundImage: "none",
  backgroundClip: "padding-box",
  borderTop: "0",
  borderRight: "0",
  borderBottom: "1px solid #eee",
  borderLeft: "0",
  borderRadius: "3px",
  transition: "all 0.25s cubic-bezier(0.4, 0, 1, 1)",
};
const iconStyle = {
  fontSize: "1.5rem",
  marginRight: "8px",
  position: "absolute",
  right: "50%",
  top: 10,
};

const filterStyle = {
  position: "relative",
  display: "flex",
  justifyContent: "space-between",
  flexWrap: "wrap",
  width: "100%",
};

const useStyles1 = makeStyles((theme) => ({
  root: {
    flexShrink: 0,
    marginLeft: theme.spacing(2.5),
  },
}));

function TablePaginationActions(props) {
  const classes = useStyles1();
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <div className={classes.root}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </div>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

const useStyles2 = makeStyles((theme) => ({
  table: {
    minWidth: 500,
  },

  tablecell: {
    fontSize: "16px",
  },
}));

const tableStyle = {
  width: 160,
  fontSize: 14,
  cursor: "pointer",
  borderBottom: "none",
  padding: "8px",
  textAlign: "center",
};
const headerStyle = { borderBottom: "none", textAlign: "center" };

const Checks = () => {
  const [selectedFromDate, handleFromDateChange] = useState(null);
  const [selectedToDate, handleToDateChange] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const [guaranteed, setGuaranteed] = useState(true);
  const [notGuaranteed, setNotGuaranteed] = useState(true);
  const [open, setOpen] = useState(null);
  const [pdfDetails, setPdfDetails] = useState({
    holderName: "",
    deliveryDate: new Date(),
    depositorName: "",
    cin: "",
    deliveryID: "",
  });
  const isMobile = useMediaQuery("(max-width: 600px)"); // Define your mobile breakpoint here

  if (isMobile) {
    inputStyle.width = "100%";
    iconStyle.right = 0;
  }
  // filter invoce

  const [searchTerm, setSearchTerm] = useState("");
  const dispatch = useDispatch();
  const history = useHistory();
  const user = JSON.parse(localStorage.getItem("profile"));
  const isLoading = useSelector((state) => state.invoices.isLoading);
  // eslint-disable-next-line
  const [openSnackbar, closeSnackbar] = useSnackbar();
  const { checks } = useSelector((state) => state.checks);

  const rows = checks.filter(
    (check) =>
      check.guaranteed == guaranteed || check.guaranteed == !notGuaranteed
  );

  const handleSelectGuranteed = (event) => {
    if (event.target.checked) {
      setGuaranteed(true);
    } else {
      setGuaranteed(false);
    }
  };
  const handleSelectNotGuranteed = (event) => {
    if (event.target.checked) {
      setNotGuaranteed(true);
    } else {
      setNotGuaranteed(false);
    }
  };
  const handleSelectRow = (event, id) => {
    if (event.target.checked) {
      setSelectedRows((prev) => [...prev, id]);
    } else {
      setSelectedRows((prev) => prev.filter((rowId) => rowId !== id));
    }
  };

  const handleSelectAllRows = (event) => {
    if (event.target.checked) {
      setSelectedRows(rows.map((row) => row._id));
    } else {
      setSelectedRows([]);
    }
  };
  const selectedChecks = checks.filter((check) =>
    selectedRows.includes(check._id)
  );

  const classes = useStyles2();
  const [page, setPage] = React.useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(rows.length);

  const emptyRows =
    rowsPerPage - Math.min(rowsPerPage, rows.length - page * rowsPerPage);

  useEffect(() => {
    dispatch(
      getChecksAction({
        holderName: searchTerm,
        page: page,
        from: selectedFromDate,
        to: selectedToDate,
      })
    );
  }, [
    dispatch,
    selectedFromDate,
    selectedToDate,
    useDebounce(searchTerm, 3000),
  ]);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleDownloadPdf = () => {
    dispatch(
      downloadChecksAction({ ...pdfDetails, checks: selectedChecks }, setOpen)
    );
  };
  if (!user) {
    history.push("/login");
  }

  if (isLoading) {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          paddingTop: "20px",
        }}
      >
        <Spinner />
      </div>
    );
  }

  if (rows.length === 0) {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          padding: "20px",
          margin: "80px",
        }}
      >
        <Container
          style={{
            width: "100%",

            paddingBottom: "20px",
            marginLeft: "-20px",
            border: "none",
          }}
        >
          <div style={filterStyle}>
            <input
              placeholder="Search with client name or ID..."
              name="search"
              type="text"
              style={inputStyle}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <SearchRoundedIcon style={iconStyle} />
          </div>
        </Container>
        <Container
          style={{
            width: "100%",

            paddingBottom: "20px",

            border: "none",
          }}
        >
          <h4>Filter with date :</h4>
          <div style={filterStyle}>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <DatePicker
                label="From"
                value={selectedFromDate}
                onChange={(date) => handleFromDateChange(date)}
              />
              <DatePicker
                label="To"
                value={selectedToDate}
                onChange={(date) => handleToDateChange(date)}
              />
            </MuiPickersUtilsProvider>
          </div>
        </Container>

        <NoData />
        <p style={{ padding: "40px", color: "gray", textAlign: "center" }}>
          No invoice yet. Click the plus icon to create invoice
        </p>
      </div>
    );
  }

  return (
    <div>
      <Container
        style={{
          width: "85%",
          paddingTop: "70px",
          paddingBottom: "50px",
          border: "none",
        }}
      >
        <Container
          style={{
            width: "100%",

            paddingBottom: "20px",
            marginLeft: "-20px",
            border: "none",
          }}
        >
          <div style={filterStyle}>
            <input
              placeholder="Search with client name or ID..."
              name="search"
              type="text"
              style={inputStyle}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <SearchRoundedIcon style={iconStyle} />
          </div>
        </Container>

        {user?.result?.role !== "assistant" && (
          <Container
            style={{
              width: "100%",

              paddingBottom: "20px",

              border: "none",
            }}
          >
            <h4>Filter with date :</h4>
            <div style={filterStyle}>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <DatePicker
                  label="From"
                  value={selectedFromDate}
                  onChange={(date) => handleFromDateChange(date)}
                />
                <DatePicker
                  label="To"
                  value={selectedToDate}
                  onChange={(date) => handleToDateChange(date)}
                />
              </MuiPickersUtilsProvider>
              <div>
                <label>Guaranteed</label>
                <Checkbox
                  checked={guaranteed}
                  onChange={(event) => handleSelectGuranteed(event)}
                />
              </div>
              <div>
                <label>Not guaranteed</label>
                <Checkbox
                  checked={notGuaranteed}
                  onChange={(event) => handleSelectNotGuranteed(event)}
                />
              </div>
            </div>
          </Container>
        )}

        <TableContainer component={Paper} elevation={0}>
          <Table className={classes.table} aria-label="custom pagination table">
            <TableHead>
              <TableRow>
                <TableCell padding="checkbox">
                  <Checkbox
                    indeterminate={
                      selectedRows.length > 0 &&
                      selectedRows.length < rows.length
                    }
                    checked={
                      rows.length > 0 && selectedRows.length === rows.length
                    }
                    onChange={handleSelectAllRows}
                  />
                </TableCell>
                <TableCell style={headerStyle}>Number</TableCell>
                <TableCell style={headerStyle}>Holder name</TableCell>
                <TableCell style={headerStyle}>Client</TableCell>
                <TableCell style={headerStyle}>Amount</TableCell>
                <TableCell style={headerStyle}>Payment date</TableCell>
                <TableCell style={headerStyle}>guaranteed</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {(rowsPerPage > 0
                ? rows.slice(
                    page * rowsPerPage,
                    page * rowsPerPage + rowsPerPage
                  )
                : rows
              ).map((row) => (
                <TableRow key={row._id} style={{ cursor: "pointer" }}>
                  <TableCell padding="checkbox">
                    <Checkbox
                      checked={selectedRows.includes(row._id)}
                      onChange={(event) => handleSelectRow(event, row._id)}
                    />
                  </TableCell>
                  <TableCell style={tableStyle}> {row?.number} </TableCell>
                  <TableCell style={tableStyle}> {row?.holderName} </TableCell>
                  <TableCell style={tableStyle}>
                    {" "}
                    {row?.invoice?.client?.name}{" "}
                  </TableCell>
                  <TableCell style={tableStyle}>{row?.amountPaid}</TableCell>
                  <TableCell style={tableStyle}>
                    {" "}
                    {moment(row.datePaid).format("DD/MM/YYYY")}{" "}
                  </TableCell>
                  <TableCell style={tableStyle}>
                    {" "}
                    {row?.guaranteed ? "Yes" : "No"}
                  </TableCell>
                </TableRow>
              ))}

              {emptyRows > 0 && (
                <TableRow style={{ height: 53 * emptyRows }}>
                  <TableCell colSpan={6} />
                </TableRow>
              )}
            </TableBody>
            <TableFooter>
              <TableRow>
                <TablePagination
                  rowsPerPageOptions={[5, 10, 25, { label: "All", value: -1 }]}
                  colSpan={6}
                  count={rows.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  SelectProps={{
                    inputProps: { "aria-label": "rows per page" },
                    native: true,
                  }}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  ActionsComponent={TablePaginationActions}
                />
              </TableRow>
            </TableFooter>
          </Table>
        </TableContainer>
        <Button onClick={() => setOpen(true)}>download</Button>
        <ChecksModal
          open={open}
          setOpen={setOpen}
          handleDownloadPdf={handleDownloadPdf}
          pdfDetails={pdfDetails}
          setPdfDetails={setPdfDetails}
        />
      </Container>
    </div>
  );
};

export default Checks;
